import { useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import './AccountOrderPages.css';

const RATING_DIMS = ['整體', '握感', '做工', '重心'];

function WriteReviewPage() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [ratings, setRatings] = useState({ 整體: 5, 握感: 4, 做工: 5, 重心: 4 });
  const [text, setText] = useState('');

  const setRating = (dim, val) => setRatings(prev => ({ ...prev, [dim]: val }));

  return (
    <main className="v3-wr">
      <div className="v3-wr-card">
        <h1>寫評價 · WRITE A REVIEW</h1>
        <p className="desc">分享你的使用感受，協助其他鏢人選擇適合的標。寫完可獲得 20 點 MICHI Point。</p>

        <div className="prod-row">
          <div className="pic"><svg viewBox="0 0 200 600"><use href="#dart-full" /></svg></div>
          <div>
            <b>TARGET SERENO G2 23g 鈴木徹 選手款 Swiss Point</b>
            <small>23g · Swiss Point · 訂單 #{id === '1' ? 'MD-251108-0428' : id}</small>
          </div>
        </div>

        <div className="v3-wr-rating">
          {RATING_DIMS.map(dim => (
            <div key={dim}>
              <label>{dim}</label>
              <div className="v3-wr-stars">
                {[1, 2, 3, 4, 5].map(n => (
                  <button
                    key={n}
                    className={n <= ratings[dim] ? 'on' : ''}
                    onClick={() => setRating(dim, n)}
                  >★</button>
                ))}
              </div>
            </div>
          ))}
        </div>

        <div className="v3-wr-field">
          <label>使用心得 · 最少 30 字</label>
          <textarea
            placeholder="例：握感比 G1 更扎實，環紋深度恰到好處不咬手。中段重心讓出手時機更穩定…"
            maxLength={500}
            value={text}
            onChange={e => setText(e.target.value)}
          />
          <div className="v3-wr-char">{text.length} / 500</div>
        </div>

        <div className="v3-wr-upload">
          <b>＋ 上傳照片或影片</b>
          <small>最多 5 張 / 1 支 30 秒影片 · 各 ≤ 10MB</small>
        </div>

        <div className="v3-wr-actions">
          <button className="back" onClick={() => navigate(`/account/orders/${id}`)}>取消</button>
          <button className="primary" onClick={() => navigate(`/account/orders/${id}`)}>
            送出評價 →
          </button>
        </div>
        <p className="v3-wr-reward">⭐ 完成評價即可獲得 <b>20 點 MICHI Point</b></p>
      </div>
    </main>
  );
}

export default WriteReviewPage;
